
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/import",
      function () {
        return require("private-next-pages/import/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/import"])
      });
    }
  